import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  ZONES_REQUESTED,
  ZONES_SUCCESS,
  ZONES_FAILURE,
  ZONE_FIND_REQUESTED,
  ZONE_FIND_SUCCESS,
  ZONE_FIND_FAILURE,
  ZONE_CREATE_REQUESTED,
  ZONE_CREATE_SUCCESS,
  ZONE_CREATE_FAILURE,
  ZONE_UPDATE_REQUESTED,
  ZONE_UPDATE_SUCCESS,
  ZONE_UPDATE_FAILURE,
  ZONE_DELETE_REQUESTED,
  ZONE_DELETE_SUCCESS,
  ZONE_DELETE_FAILURE,
} from '../types';

export const zonesRequested = () => {
  return {
    type: ZONES_REQUESTED
  }
};

export const zonesSuccess = (zones) => {
  return {
    type: ZONES_SUCCESS,
    payload: zones
  }
};

export const zonesFailure = () => {
  return {
    type: ZONES_FAILURE
  }
};


export const zoneFindRequested = () => {
  return {
    type: ZONE_FIND_REQUESTED
  }
};

export const zoneFindSuccess = (zone) => {
  return {
    type: ZONE_FIND_SUCCESS,
    payload: zone
  }
};

export const zoneFindFailure = () => {
  return {
    type: ZONE_FIND_FAILURE
  }
};


export const zoneCreateRequested = () => {
  return {
    type: ZONE_CREATE_REQUESTED
  }
};

export const zoneCreateSuccess = (zone) => {
  return {
    type: ZONE_CREATE_SUCCESS,
    payload: zone
  }
};

export const zoneCreateFailure = () => {
  return {
    type: ZONE_CREATE_FAILURE
  }
};

export const zoneUpdateRequested = () => {
  return {
    type: ZONE_UPDATE_REQUESTED
  }
};

export const zoneUpdateSuccess = (zone) => {
  return {
    type: ZONE_UPDATE_SUCCESS,
    payload: zone
  }
};

export const zoneUpdateFailure = () => {
  return {
    type: ZONE_UPDATE_FAILURE
  }
};


export const zoneDisableRequested = (zoneId) => {
  return {
    type: ZONE_DELETE_REQUESTED,
    zoneId: zoneId
  }
};

export const zoneDisableSuccess = () => {
  return {
    type: ZONE_DELETE_SUCCESS
  }
};

export const zoneDisableFailure = () => {
  return {
    type: ZONE_DELETE_FAILURE
  }
};

export const zonesIndex = (signedPayload) => {
  return (dispatch) => {
    dispatch(zonesRequested());

    let endPoint = Config.baseUrl + Config.zones;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(zonesSuccess(response.data));
      })
  }
}

export const zoneFind = (signedPayload, zoneId) => {
  return (dispatch) => {
    dispatch(zoneFindRequested());

    let endPoint = Config.baseUrl + Config.zone + zoneId;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(zoneFindSuccess(response.data));
      })
      .catch((error) => {
        dispatch(zoneFindFailure());
      });

  }
}


export const zoneCreate = (signedPayload, label, description, priority) => {
  return (dispatch) => {
    dispatch(zoneCreateRequested());

    let endPoint = Config.baseUrl + Config.zone;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { label: label, description: description, priority: priority }, { headers: headers })
      .then((response) => {
        dispatch(zoneCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(zoneCreateFailure());
      });

  }
}

export const zoneUpdate = (signedPayload, id, label, description, priority) => {
  return (dispatch) => {
    dispatch(zoneUpdateRequested());

    console.log(id);

    let endPoint = Config.baseUrl + Config.zone;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.put(endPoint, { id: id, label: label, description: description, priority: priority }, { headers: headers })
      .then((response) => {
        dispatch(zoneUpdateSuccess(response.data));
      })

  }
}

export const zoneDisable = (signedPayload, id) => {
  return (dispatch) => {
    dispatch(zoneDisableRequested(id));

    let endPoint = Config.baseUrl + Config.zone + id;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(zoneDisableSuccess(response.data));
      })
      .catch((error) => {
        dispatch(zoneDisableFailure());
      });
  }
}